import {
Component,
Injector,
Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";

import {
  DISPLAY_TYPE,
  IWidgetConfig,
  StylableComponent,
  provideAsWidgetRef,
  Parent,
  styler,
  register,
  APPLY_STYLES_TYPE
} from "@wm/components-base";
import {WmsTranscludeDirective} from "../wms-transclude/wms-transclude.directive";

const DEFAULT_CLS = 'app-header clearfix';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-header',
  hostClass: DEFAULT_CLS
};

@Component({
  selector: '[wmHeader]',
  template: `<div class="app-header-menu" data-role="page-left-panel-icon">
    <a class="app-header-action">
      <i class="wi wi-menu"></i>
    </a>
  </div>
  <div class="app-header-container" wmsTransclude partial-container-target page-container-target >
    @if (isInlineContent) {
      <ng-content></ng-content>
    }
  </div>
  `,
  providers: [
    provideAsWidgetRef(HeaderComponent)
  ],
  exportAs: 'wmHeader',
  standalone: true,
  imports: [CommonModule, WmsTranscludeDirective],
  styles: []
})
export class HeaderComponent extends StylableComponent {
  static initializeProps = register('wm-header');

  protected isInlineContent: boolean = true;
  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this, APPLY_STYLES_TYPE.CONTAINER);
  }

}

